import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { CenterFlexRow, BackButton } from "../../styles";
import SmsTempleteAddEdit from "./SmsTempleteAddEdit";
import { PerPage } from "helpers/system-config";
import { MenuItem } from "react-bootstrap";
import {
  ModalTrigger,
  FormControl,
  ActionButtons,
  Table,
  DataWithLoader,
  ControlLabel,
  ReportPagination,
  SeachForm,
  DataWrapperClass,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";
import { CustomDropdown } from "../../../../common/components";

class SmsTemplete extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `Sms Template`;
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModalShow = this.closeModalShow.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.clearSearchField = this.clearSearchField.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      infoData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SelectedList: [],
      ary: [],
      show: false,
    };
  }

  handleModal() {
    this.setState({ show: !this.state.show });
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  clearSearchField() {
    this.setState({ searchValue: "" });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    const list = this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
    });
    this.mAPI.sendPostAPI(
      `setting/sms-templete/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.setState({ currentPage: 1 });
        this.getSmsTemplete(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      listData: teamList,
      searchValue: e.target.value,
      currentPage: 1,
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getSmsTemplete(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    this.getSmsTemplete(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  getSmsTemplete(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/sms-templete?limit=${perPage}&page_no=${page}&orderBy=create_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loading: false });

        if (data && data.data) {
          const newListData = data.data.map((item) => {
            return {
              ...item,
              selected: false,
            };
          });
          that.setState({
            MasterChecked: false,
            listData: newListData,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [], total: 0 });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getSmsTemplete(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getSmsTemplete(1, perPage, this.state.search);
  }

  closeModalShow() {
    this.setState({ show: false });
  }
  openModalShow(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({
        showHide: true,
        infoData: undefined,
        editData: undefined,
      });
    }
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated === true) {
      this.getSmsTemplete(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteSmsTemplete(tSmsTemplete) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/sms-templete/${tSmsTemplete._id}`,
      undefined,
      (data) => {
        // that.getSmsTemplete(
        //   this.state.currentPage,
        //   this.state.perPageCount,
        //   this.state.search
        // );
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tSmsTemplete._id);
        const totalItemsOnCurrentPage = tD.length;
        if (totalItemsOnCurrentPage === 0 && that.state.currentPage > 1) {
          that.setState({ currentPage: 1 }, () => {
            that.getList(1, that.state.perPageCount, that.state.search);
          });
        } else {
          that.setState({ listData: tD });
          that.getList(
            that.state.currentPage,
            that.state.perPageCount,
            that.state.search
          );
        }
        // Alert.success(data.message);
        Alert.success(`${this.moduleName}  deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  editSmsTemplete(tSmsTemplete) {
    return (
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(tSmsTemplete)}
      />
    );
  }

  getIDDetails(tSmsTemplete) {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/sms-templete/${tSmsTemplete}`,
      (data) => {
        this.setState({ loading: false });

        if (data) {
        } else {
        }
      },
      (error, data) => {}
    );
  }

  renderActions(tSmsTemplete, index) {
    const { __ } = this.context;
    return (
      <ActionButtons>
        {this.editSmsTemplete(tSmsTemplete)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem style={{ marginLeft: "0px" }}>
            <a
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteSmsTemplete(tSmsTemplete, e);
                })
              }
            >
              {"Delete"}
            </a>
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    return formData;
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title="Sms Template"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          openModalShow={this.openModalShow}
          dialogClassName={this.state.modalType}
        >
          <SmsTempleteAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            editData={this.state.editData}
            infoData={this.state.infoData}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
            clearSearchField={this.clearSearchField}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("SMS Template"), link: "/settings/SmsTemplate" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("NAME")}</th>
              <th>{__("TYPE")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="SmsTemplete">
            {this.state.listData &&
              this.state.listData.map((tSmsTemplete, index) => (
                <tr key={tSmsTemplete._id}>
                  <td onClick={this.onClick}>
                    <FormControl
                      componentClass="checkbox"
                      checked={tSmsTemplete.selected}
                      onChange={(e) => this.onItemCheck(e, tSmsTemplete)}
                    />
                  </td>
                  <td className="">{tSmsTemplete.name}</td>
                  <td>{tSmsTemplete.type}</td>
                  <td>{this.renderActions(tSmsTemplete, index)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{`Sms Template`}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span className="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 && (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    )}
                  </div>
                }
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="Sorry..! No SMS Template Found"
                  emptyImage="/images/emptyimg.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

SmsTemplete.contextTypes = {
  __: PropTypes.func,
};

export default SmsTemplete;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsTemplete/components/SmsTemplete.js